module.exports = __webpack_public_path__ + "static/media/favourite-select.2ea3a72f.svg";